export interface ISession {
  startedAt: Date | null
  endedAt: Date
  userId: string | undefined
}

const DIETITIAN_SESSIONS_KEY = 'DIETITIAN_SESSIONS'

const toIsoString = (value: Date | string | null) =>
  value instanceof Date ? value.toISOString() : value ?? ''

// Identity of a session for de-duplication. Accepts both Date and ISO-string
// forms since sessions round-trip through JSON in localStorage.
export const sessionKey = ({ startedAt, endedAt, userId }: ISession) =>
  `${userId ?? ''}|${toIsoString(startedAt)}|${toIsoString(endedAt)}`

export const storedSessions = (): ISession[] => {
  const sessions = JSON.parse(localStorage.getItem(DIETITIAN_SESSIONS_KEY) || '[]')
  // after parsing dates are no more of type Date but String
  sessions.forEach((session: ISession) => {
    if (session.startedAt) session.startedAt = new Date(session.startedAt)
    if (session.endedAt) session.endedAt = new Date(session.endedAt)
  })
  return sessions
}

export const clearStoredSessions = () => {
  return localStorage.removeItem(DIETITIAN_SESSIONS_KEY)
}

const persistSessions = (sessions: ISession[]) => {
  if (sessions.length) {
    localStorage.setItem(DIETITIAN_SESSIONS_KEY, JSON.stringify(sessions))
  } else {
    clearStoredSessions()
  }
}

export const storeSession = (session: ISession) => {
  const sessions = storedSessions()
  const key = sessionKey(session)
  if (sessions.some((stored) => sessionKey(stored) === key)) return
  sessions.push(session)
  persistSessions(sessions)
}

export const removeStoredSession = (session: ISession) => {
  const key = sessionKey(session)
  persistSessions(storedSessions().filter((stored) => sessionKey(stored) !== key))
}
